import log from 'salvo-lite/log'

class VariantDropdowns {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._selects = elem.querySelectorAll('.variant-select')
    }

    onInit () {
        log.debug(this.constructor.name, 'initialised', this)

        this._initSelects()
    }

    _initSelects () {
        NodeList.prototype.indexOf = Array.prototype.indexOf
        NodeList.prototype.filter = Array.prototype.filter

        if (this._selects.length > 1) {
            this._sortMultipleOptions(this._selects)

            this._selects.forEach(select => {
                select.addEventListener('change', e => {
                    this._sortMultipleOptions(this._selects)
                })
            })
        } else {
            this._sortSingleOption(this._selects[0])
        }
    }

    _sortSingleOption (select) {
        this._updateLabel(select)

        const options = select.querySelectorAll('option')

        options.forEach(option => {
            if (option.dataset.available === 'false') option.disabled = false
        })

        select.addEventListener('change', () => {
            this._updateLabel(select)
        })
    }

    _sortMultipleOptions (allSelects) {
        const options = this._elem.querySelectorAll('option')

        options.forEach(option => {
            option.disabled = true
        })

        allSelects.forEach(thisSelect => {
            this._updateLabel(thisSelect)

            const referenceSelects = allSelects.filter(select => select !== thisSelect)
            const index = allSelects.indexOf(thisSelect)
            const reducedAvailableArr = []
            const selectedOptionArr = []

            referenceSelects.forEach(referenceSelect => {
                const selectedOption = referenceSelect.querySelectorAll('option')[referenceSelect.selectedIndex]
                selectedOptionArr.push(selectedOption)
            })

            referenceSelects.forEach(select => {
                const selectedOption = select.querySelectorAll('option')[select.selectedIndex]
                const availableArr = JSON.parse(selectedOption.dataset.availableVariants)

                availableArr.forEach(item => {
                    let matchCount = 0

                    selectedOptionArr.forEach(option => {
                        if (item.includes(option.value)) matchCount++
                    })

                    if (matchCount === selectedOptionArr.length) if (!reducedAvailableArr.includes(item)) reducedAvailableArr.push(item)
                })
            })

            reducedAvailableArr.forEach(variantTitle => {
                const optionValues = variantTitle.split(' / ')
                const optionValue = optionValues[index]
                const option = this._elem.querySelector(`option[value="${optionValue}"]`)
                option.disabled = false
            })
        })
    }

    _updateLabel (select) {
        const options = select.querySelectorAll('option')
        const label = options[select.selectedIndex].parentNode.previousElementSibling
        label.textContent = options[select.selectedIndex].textContent
    }
}

export default VariantDropdowns



// WEBPACK FOOTER //
// ./src/resources/scripts/components/VariantDropdowns.js